import FixaTable, {
  FixaTableBody,
  FixaTableHeader,
} from "@coworker/apprestructured/src/shared/wrappers/FixaTable/FixaTable";
import { formatDateByLocale } from "@coworker/reusable/formatters/date.formatter";
import { BasePermission } from "../../types/BasePermission";
type Props = {
  permissions: BasePermission[];
  isLoading: boolean;
};

const PermissionsPanel = ({ permissions, isLoading }: Props) => {
  return (
    <FixaTable fullWidth>
      <FixaTableHeader>
        <tr>
          <th>Code</th>
          <th>Description</th>
          <th>Created</th>
          <th>Updated</th>
        </tr>
      </FixaTableHeader>
      <FixaTableBody>
        {isLoading ? (
          <tr>
            <td colSpan={4}>Loading...</td>
          </tr>
        ) : permissions.length === 0 ? (
          <tr>
            <td colSpan={4}>No permissions found</td>
          </tr>
        ) : (
          permissions.map((permission: BasePermission) => (
            <tr key={permission.code}>
              <td>{permission.code}</td>
              <td>{permission.description}</td>
              <td>
                {permission.created_at
                  ? formatDateByLocale(permission.created_at)
                  : "-"}
              </td>
              <td>
                {permission.updated_at
                  ? formatDateByLocale(permission.updated_at)
                  : "-"}
              </td>
            </tr>
          ))
        )}
      </FixaTableBody>
    </FixaTable>
  );
};

export default PermissionsPanel;
